import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/SSOLogin',
      name: 'SSOLogin',
      component: () => import('../pages/SSOLogin.vue')
    },
    {
      path: '/unAuth',
      name: 'unAuth',
      component: () => import('../pages/unAuth.vue')
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('../pages/DataManagePages/Layout/Layout.vue'),
      children: [
        {
          path: '/Estate',
          name: 'Estate',
          component: () => import('../pages/DataManagePages/Estate')
        },
        {
          path: '/Park',
          name: 'Park',
          component: () => import('../pages/DataManagePages/Park')
        },
        {
          path: '/Yugao',
          name: 'Yugao',
          component: () => import('../pages/DataManagePages/Yugao')
        },
        {
          path: '/Hotel',
          name: 'Hotel',
          component: () => import('../pages/DataManagePages/Hotel')
        },
        {
          path: '/Kangyang',
          name: 'Kangyang',
          component: () => import('../pages/DataManagePages/Kangyang')
        },
        {
          path: '/MapEstate',
          name: 'MapEstate',
          component: () => import('../pages/Map/MapEstate')
        },
        {
          path: '/MapHotel',
          name: 'MapHotel',
          component: () => import('../pages/Map/MapHotel')
        },
        {
          path: '/MapPark',
          name: 'MapPark',
          component: () => import('../pages/Map/MapPark')
        },

        {
          path: '/ProjectList',
          name: 'ProjectList',
          component: () => import('../pages/DetailPages/ProjectList.vue')
        },
        {
          path: '/EstateContractList',
          name: 'EstateContractList',
          component: () => import('../pages/DetailPages/EstateContractList.vue')
        },
        {
          path: '/ParkContractList',
          name: 'ParkContractList',
          component: () => import('../pages/DetailPages/ParkContractList.vue')
        },
        {
          path: '/YugaoContractList',
          name: 'YugaoContractList',
          component: () => import('../pages/DetailPages/YugaoContractList.vue')
        },
        {
          path: '/RentContractList',
          name: 'RentContractList',
          component: () => import('../pages/DetailPages/RentContractList.vue')
        },
        {
          path: '/DqContractList',
          name: 'DqContractList',
          component: () => import('../pages/DetailPages/DqContractList.vue')
        },
        {
          path: '/CqContractList',
          name: 'CqContractList',
          component: () => import('../pages/DetailPages/CqContractList.vue')
        },
        {
          path: '/QsContractList',
          name: 'QsContractList',
          component: () => import('../pages/DetailPages/QsContractList.vue')
        },
        {
          path: '/KzContractList',
          name: 'KzContractList',
          component: () => import('../pages/DetailPages/KzContractList.vue')
        },
        {
          path: '/SafetyList',
          name: 'SafetyList',
          component: () => import('../pages/DetailPages/SafetyList.vue')
        },
        {
          path: '/Unmatched',
          name: 'Unmatched',
          component: () => import('../pages/DetailPages/Unmatched.vue')
        },
      ],
    },
    {
      path: '/Home',
      name: 'Home',
      component: () => import('../pages/Home.vue')
    },
    {
      path: '/AssetBoard',
      name: 'AssetBoard',
      component: () => import('../pages/AssetBoard.vue')
    },

    {
      path: '/detail',
      name: 'layout',
      component: () => import('../pages/DetailPages/Layout/DetailLayout.vue'),
      children: [
        // {
        //   path: '/ProjectList',
        //   name: 'ProjectList',
        //   component: () => import('../pages/DetailPages/ProjectList.vue')
        // },
        // {
        //   path: '/EstateContractList',
        //   name: 'EstateContractList',
        //   component: () => import('../pages/DetailPages/EstateContractList.vue')
        // },
        // {
        //   path: '/ParkContractList',
        //   name: 'ParkContractList',
        //   component: () => import('../pages/DetailPages/ParkContractList.vue')
        // },
        // {
        //   path: '/YugaoContractList',
        //   name: 'YugaoContractList',
        //   component: () => import('../pages/DetailPages/YugaoContractList.vue')
        // },
        // {
        //   path: '/RentContractList',
        //   name: 'RentContractList',
        //   component: () => import('../pages/DetailPages/RentContractList.vue')
        // },
        // {
        //   path: '/DqContractList',
        //   name: 'DqContractList',
        //   component: () => import('../pages/DetailPages/DqContractList.vue')
        // },
        // {
        //   path: '/CqContractList',
        //   name: 'CqContractList',
        //   component: () => import('../pages/DetailPages/CqContractList.vue')
        // },
        // {
        //   path: '/QsContractList',
        //   name: 'QsContractList',
        //   component: () => import('../pages/DetailPages/QsContractList.vue')
        // },
        // {
        //   path: '/KzContractList',
        //   name: 'KzContractList',
        //   component: () => import('../pages/DetailPages/KzContractList.vue')
        // },
        // {
        //   path: '/SafetyList',
        //   name: 'SafetyList',
        //   component: () => import('../pages/DetailPages/SafetyList.vue')
        // },
        // {
        //   path: '/Unmatched',
        //   name: 'Unmatched',
        //   component: () => import('../pages/DetailPages/Unmatched.vue')
        // },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js